export default __webpack_public_path__ + "static/media/analytics.2fdf3ae8.svg";